import { Component, h } from 'preact';

class TcrCurrencyInput extends Component
{
    constructor(props)
    {
        super(props);

        this.validateInput = this.validateInput.bind(this);
        this.formatValue = this.formatValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onPaste = this.onPaste.bind(this);

        this.state = {
            value: '0,00'
        };
    }

    onPaste(event)
    {
        if (typeof this.props.onPaste == 'function')
        {
            this.ref.blur();
            return this.props.onPaste(event);
        }
    }

    validateInput(event)
    {
        let rawvalue = event.target.value;

        const lastComma = rawvalue.lastIndexOf(',');
        const lastPeriod = rawvalue.lastIndexOf('.');

        if (lastPeriod > lastComma)
        {
            // 1,024.56
            //remove all commas, then continue normally
            rawvalue = rawvalue.replace(/,/g, '');
        }
        else if (lastComma > lastPeriod)
        {
            // 1.024,56
            //remove all periods, then continue normally
            rawvalue = rawvalue.replace(/\./g, '');
        }

        //change decimal to comma
        rawvalue = rawvalue.replace(/\./g, ',');

        //remove invalid characters from input
        rawvalue = rawvalue.replace(/[^0-9,\-]/g, '');

        //prevent multiple commas
        rawvalue = rawvalue.replace(/(\d*,\d*),/g, '$1');

        //repace more than 2 digits after the comma
        rawvalue = rawvalue.replace(/(\d*,\d{2}).+/g, '$1');

        //repace more than 15 digits before the comma
        rawvalue = rawvalue.replace(/(\d{15})\d+(,\d*)?/g, '$1$2');

        let value = '' + rawvalue;

        //add comma to values without
        value = value.replace(/^(\d*)$/g, '$1,');

        //add leading zero to values starting with comma
        value = value.replace(/^,(.*)/g, '0,$1');

        //add trailing zeroes to values ending on comma
        value = value.replace(/(\d*),$/g, '$1,00');
        value = value.replace(/(\d*,\d{1})$/g, '$10');

        console.log('raw input:' + rawvalue);
        console.log('parsed input:' + value);
        this.setState({
            value: rawvalue
        }, () => {
            this.props.onInput({
                target: {
                    value: value,
                    dataset: {
                        field: this.props.field
                    }
                }
            });
        });
    }

    onFocus()
    {
        let value = typeof this.props.value !== 'string' ? '0.00' : this.props.value;
        value = value.replace(/\./g, ',');
        value = value.replace(/[^0-9,]/g, '');

        this.setState({
            value: value,
            focus: true
        });
    }

    onBlur()
    {
        this.setState({
            focus: false
        });
    }

    formatValue()
    {
        if (this.state.focus)
        {
            return this.state.value;
        }
        else
        {
            let formatter = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
            return formatter.format(parseFloat(this.props.value) || 0);
        }
    }

    render()
    {
        return <input ref={dom => { this.ref = dom;}} type="text" value={this.formatValue()} data-field={this.props.field} onInput={this.validateInput} onFocus={this.onFocus} onBlur={this.onBlur} onPaste={this.onPaste} />;
    }
}

export { TcrCurrencyInput };